import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';

const parsedSampleRate = parseFloat(process.env.MIX_SENTRY_TRACES_SAMPLE_RATE);

const initSentry = () => {
    Sentry.init({
        dsn: process.env.MIX_SENTRY_FRONTEND,
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: isNaN(parsedSampleRate) ? 1.0 : parsedSampleRate,
    });
};

export default initSentry;
